import React from 'react';
import { Check, Download, Star } from 'lucide-react';
import AudioPlayer from '../AudioPlayer';
import { songLabel, downloadHref as dl } from '../../lib/song';

export default function VersionList({ req, picked, onToggle, onFeature }) {
  if (!req.versions?.length) {
    return <p className="mt-6 text-cream/55 text-sm rounded-2xl border hairline p-5 bg-panel2/40">Perry is in the studio with your song. You&rsquo;ll get an email the moment your versions are ready to hear.</p>;
  }
  const owned = req.purchased_versions || [];
  return (
    <div className="mt-6 space-y-4">
      {req.versions.map((v) => {
        const isMine = owned.includes(v.id);
        const featured = isMine && req.purchased_version === v.id;
        const active = isMine || picked.includes(v.id);
        const pick = () => !isMine && onToggle(v.id);
        return (
          <div key={v.id} role="button" tabIndex={0} data-testid={`version-card-${v.id}`} aria-pressed={active} onClick={pick} onKeyDown={(e) => e.key === 'Enter' && pick()}
            className={`w-full text-left rounded-2xl border p-4 transition-all duration-300 ${isMine ? 'border-emerald-500/40 bg-emerald-500/[0.04] cursor-default' : active ? 'border-gold/60 bg-gold/[0.04] cursor-pointer' : 'hairline hover:border-gold/30 cursor-pointer'}`}>
            <div className="flex items-center gap-3 mb-3 flex-wrap">
              <span className={`grid place-items-center w-5 h-5 rounded-md border shrink-0 ${isMine ? 'bg-emerald-500 border-emerald-500' : active ? 'bg-gold border-gold' : 'border-cream/30'}`}>{active && <Check size={12} className="text-ink" />}</span>
              <h3 className="font-display text-xl text-cream" data-testid={`version-title-${v.id}`}>{v.id}. <span className="text-cream/55 text-base font-sans">Song Title:</span> {songLabel(v)}</h3>
              <span className="text-sm text-cream/50">{v.genre}</span>
              {isMine && <span data-testid={`owned-badge-${v.id}`} className="ml-auto text-[10px] tracking-widest uppercase text-emerald-400 border border-emerald-500/40 rounded-full px-2 py-0.5">Yours</span>}
            </div>
            <AudioPlayer id={`${req.code}-${v.id}`} src={v.audio} previewSeconds={req.preview_seconds} locked={!isMine} />
            {isMine && (
              <div className="mt-3 flex items-center gap-4 flex-wrap">
                {dl(v) && <a href={dl(v)} download onClick={(e) => e.stopPropagation()} data-testid={`download-version-${v.id}`} className="inline-flex items-center gap-2 text-xs text-gold hover:underline"><Download size={13} /> Download &ldquo;{songLabel(v)}&rdquo;</a>}
                {owned.length > 1 && (
                  featured
                    ? <span data-testid={`featured-badge-${v.id}`} className="inline-flex items-center gap-1 text-xs text-cream/70"><Star size={12} className="text-gold fill-gold" /> Featured on your share page</span>
                    : <button type="button" onClick={(e) => { e.stopPropagation(); onFeature(v.id); }} data-testid={`feature-btn-${v.id}`} className="inline-flex items-center gap-1 text-xs text-cream/50 hover:text-gold transition-colors"><Star size={12} /> Make this the featured version</button>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
